import styled, { css, keyframes } from 'styled-components'
import {
  ANATOMY_COMPACT,
  anatomyCompact,
} from '~/pages/anatomy/libs/responsive'
import { Container } from '~/shared/components/Container'
import { Option } from '~/shared/components/Option'
import { BREAKPOINTS, COLORS } from '~/shared/constants/uiConstants'

const slideInFromRight = keyframes`
  from { opacity: 0; transform: translateX(10%)}
  to { opacity: 1; transform: translateX(0)}
`

export const Styles = {
  Root: styled.div`
    width: 100%;
    height: calc(100dvh - var(--header-height));
    overflow-y: auto;

    &:before {
      position: absolute;
      z-index: -1;
      inset: 0;
      content: '';
      background-color: ${COLORS.GRAY_100};
    }
  `,

  StyledContainer: styled(Container)<{ $isAnatomyV2?: boolean }>`
    padding: 24px 16px;
    justify-content: flex-start;
    gap: ${({ $isAnatomyV2 }) => ($isAnatomyV2 ? '0' : '50px')};

    ${anatomyCompact} {
      gap: ${({ $isAnatomyV2 }) =>
        $isAnatomyV2 ? '0' : ANATOMY_COMPACT.spacing.s50};
    }
  `,

  Question: styled.p<{ $isAnatomyV2?: boolean }>`
    font-size: 22px;
    line-height: 24px;
    font-weight: 700;
    margin-top: ${({ $isAnatomyV2 }) => ($isAnatomyV2 ? '24px' : '0')};
    margin-bottom: 16px;
    color: ${COLORS.BLACK};
  `,

  StatementContainer: styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    background-color: ${COLORS.PURPLE_100};
    border-radius: 16px;
    min-height: 100px;
  `,

  Statement: styled.p`
    font-size: 15px;
    line-height: 20px;
    color: ${COLORS.BLACK};
  `,

  ImageContainer: styled.div`
    box-shadow: 0 8px 12px -6px #3e0b8f1a;
    border-radius: 12px;
    min-height: 258px;
  `,

  Title: styled.h1`
    text-align: center;
    font-size: 22px;
    line-height: 24px;
    font-weight: 700;
    color: ${COLORS.BLACK};
    margin-bottom: 8px;
  `,

  Subtitle: styled.h2<{ $isTextLeft?: boolean }>`
    text-align: ${({ $isTextLeft }) => ($isTextLeft ? 'auto' : 'center')};
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.BLACK};
  `,

  StyledOption: styled(Option)<{
    $index: number
    $withAdditionalValue?: boolean
  }>`
    max-width: ${BREAKPOINTS[343]}px;
    margin: 0 auto;
    border-radius: 12px;
    padding: 16px 12px;
    opacity: 0;
    animation: ${slideInFromRight} 0.4s ease-out forwards;
    animation-delay: ${({ $index }) => 0.15 + $index * 0.08}s;

    &:not(:last-of-type) {
      margin-bottom: 12px;
    }

    ${({ $withAdditionalValue }) =>
      $withAdditionalValue &&
      css`
        display: flex;
        justify-content: space-between;
      `}
  `,

  Value: styled.p`
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.BLACK};
  `,

  AdditionalValue: styled.p`
    font-size: 14px;
    line-height: 18px;
    color: #00000080;
  `,

  OptionsBottomWrapper: styled.div`
    margin-top: auto;
  `,
} as const
